import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
  Typography,
  Grid,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { Fragment, memo, useState } from "react";
import { useNotify, Button, useMutation } from "react-admin";
import InvoiceInput from "./InvoiceInput";

interface TaggingCreditNoteButtonProps {
  selectedCreditNote: ICreditNote;
  customerId: number;
}

const TaggingCreditNoteButton = ({
  selectedCreditNote,
  customerId,
}: TaggingCreditNoteButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedInvoice, setSelectedInvoice] = useState<IInvoice>();
  const notify = useNotify();

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    cancelButton: {
      backgroundColor: "#eeeeee",
      color: "black",
    },
    button: {
      backgroundColor: "#ffbf00",
    },
  });

  const classes = useStyles();

  const [handleTaggingCreditNote, { loading }] = useMutation(
    {
      type: "customPatch",
      resource: `commercialDocuments/${selectedCreditNote.id}/TagTo/${selectedInvoice?.id}`,
      payload: {},
    },
    {
      onSuccess: () => {
        notify(`Successfully tag the credit note.`, "info");
        window.location.reload();
      },
      onFailure: (error) => {
        notify(
          `Failed tag the credit note, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log("CN", selectedCreditNote);
  console.log("IN", selectedInvoice);

  return (
    <Fragment>
      <Button
        label={`Tag to Invoice`}
        className={classes.button}
        onClick={handleOpenDialog}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Tag the Credit Note</DialogTitle>
        <DialogContent>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2">Select Invoice</Typography>
            </Grid>
            <Grid item xs={12}>
              <InvoiceInput
                setSelectedInvoice={setSelectedInvoice}
                accountingCustomerId={customerId}
                creditNoteAmount={selectedCreditNote.total}
                label="Invoice"
              />
            </Grid>
          </SanitizedGrid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleTaggingCreditNote}
            color="primary"
            undoable={false}
            label={loading ? `Loading...` : `Tag`}
            disabled={selectedInvoice ? loading : true}
          />
          <Button
            onClick={handleClose}
            color="secondary"
            label="Cancel"
            className={classes.cancelButton}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(TaggingCreditNoteButton);
